import { 
  GET_LIST_MATERIAL_CATEGORY, 
  GET_LIST_MATERIAL_CATEGORY_SUCCESS, 
  GET_LIST_MATERIAL_CATEGORY_FAILURE,
  GET_ALL_MATERIALS,
  GET_ALL_MATERIALS_SUCCESS,
  GET_ALL_MATERIALS_FAILURE,
  GENERATE_MATERIAL_REPORT,
  GENERATE_MATERIAL_REPORT_SUCCESS,
  GENERATE_MATERIAL_REPORT_FAILURE,
  CLEAR_GENERATE_MATERIAL_REPORT,
  GET_MATERIAL_REPORT_VERSIONS,
  GET_MATERIAL_REPORT_VERSIONS_SUCCESS,
  GET_MATERIAL_REPORT_VERSIONS_FAILURE,
  GENERATE_MATERIAL_REGISTRY_REPORT,
  GENERATE_MATERIAL_REGISTRY_REPORT_SUCCESS,
  GENERATE_MATERIAL_REGISTRY_REPORT_FAILURE,
  CLEAR_MATERIAL_REGISTRY_REPORT,
  GET_REGISTRY_REPORT_VERSIONS,
  GET_REGISTRY_REPORT_VERSIONS_SUCCESS,
  GET_REGISTRY_REPORT_VERSIONS_FAILURE,
  GET_INSPECTION_PERSONNEL_DOCUMENTS,
  GET_INSPECTION_PERSONNEL_DOCUMENTS_SUCCESS,
  GET_INSPECTION_PERSONNEL_DOCUMENTS_FAILURE,
  GET_REGISTRY_BOOK_VERSIONS,
  GET_REGISTRY_BOOK_VERSIONS_SUCCESS,
  GET_REGISTRY_BOOK_VERSIONS_FAILURE,
  GET_MATERIAL_REGISTRY_REPORT_VERSIONS,
  GET_MATERIAL_REGISTRY_REPORT_VERSIONS_SUCCESS,
  GET_MATERIAL_REGISTRY_REPORT_VERSIONS_FAILURE,
  GET_MATERIAL_TRACEABILITY_ALL_SUMMARY,
  GET_MATERIAL_TRACEABILITY_ALL_SUMMARY_SUCCESS,
  GET_MATERIAL_TRACEABILITY_ALL_SUMMARY_FAILURE,
  GET_MATERIAL_TRACEABILITY_ALL_DATA,
  GET_MATERIAL_TRACEABILITY_ALL_DATA_SUCCESS,
  GET_MATERIAL_TRACEABILITY_ALL_DATA_FAILURE
} from "./types";

// Material Category Actions
const getListMaterialCategory = (payload = {}) => ({
  type: GET_LIST_MATERIAL_CATEGORY,
  ...payload
});
const getListMaterialCategorySuccess = (payload) => ({
  type: GET_LIST_MATERIAL_CATEGORY_SUCCESS,
  ...payload
});
const getListMaterialCategoryFailure = () => ({
  type: GET_LIST_MATERIAL_CATEGORY_FAILURE
});

// Get All Materials Actions
const getAllMaterials = (payload) => ({
  type: GET_ALL_MATERIALS,
  ...payload
});
const getAllMaterialsSuccess = (payload) => ({
  type: GET_ALL_MATERIALS_SUCCESS,
  ...payload
});
const getAllMaterialsFailure = () => ({
  type: GET_ALL_MATERIALS_FAILURE
});

// Generate Material Report Actions
const generateMaterialReport = (payload) => ({
  type: GENERATE_MATERIAL_REPORT,
  payload
});
const generateMaterialReportSuccess = (payload) => ({
  type: GENERATE_MATERIAL_REPORT_SUCCESS,
  payload
});
const generateMaterialReportFailure = (error) => ({
  type: GENERATE_MATERIAL_REPORT_FAILURE,
  error
});
const clearGenerateMaterialReport = () => ({
  type: CLEAR_GENERATE_MATERIAL_REPORT
});

// Get Material Report Versions Actions (old - for pipeId and reportType)
const getMaterialReportVersions = (pipeId, reportType) => ({
  type: GET_MATERIAL_REPORT_VERSIONS,
  pipeId,
  reportType
});
const getMaterialReportVersionsSuccess = (payload) => ({
  type: GET_MATERIAL_REPORT_VERSIONS_SUCCESS,
  payload
});
const getMaterialReportVersionsFailure = (error) => ({
  type: GET_MATERIAL_REPORT_VERSIONS_FAILURE,
  error
});

// Generate Material Registry Report Actions (Equipment/Consumable)
const generateMaterialRegistryReport = (payload) => ({
  type: GENERATE_MATERIAL_REGISTRY_REPORT,
  payload
});
const generateMaterialRegistryReportSuccess = (payload) => ({
  type: GENERATE_MATERIAL_REGISTRY_REPORT_SUCCESS,
  payload
});
const generateMaterialRegistryReportFailure = (error) => ({
  type: GENERATE_MATERIAL_REGISTRY_REPORT_FAILURE,
  error
});
const clearMaterialRegistryReport = () => ({
  type: CLEAR_MATERIAL_REGISTRY_REPORT
});

// Get Registry Report Versions Actions (new API)
const getRegistryReportVersions = (projectId) => ({
  type: GET_REGISTRY_REPORT_VERSIONS,
  projectId
});
const getRegistryReportVersionsSuccess = (payload) => ({
  type: GET_REGISTRY_REPORT_VERSIONS_SUCCESS,
  payload
});
const getRegistryReportVersionsFailure = (error) => ({
  type: GET_REGISTRY_REPORT_VERSIONS_FAILURE,
  error
});

// Get Inspection Personnel Documents Actions (QC Inspection Personnel)
const getInspectionPersonnelDocuments = (projectId) => ({
  type: GET_INSPECTION_PERSONNEL_DOCUMENTS,
  projectId
});
const getInspectionPersonnelDocumentsSuccess = (payload) => ({
  type: GET_INSPECTION_PERSONNEL_DOCUMENTS_SUCCESS,
  payload
});
const getInspectionPersonnelDocumentsFailure = (error) => ({
  type: GET_INSPECTION_PERSONNEL_DOCUMENTS_FAILURE,
  error
});

// Get Registry Book Versions Actions (previously generated registry books)
const getRegistryBookVersions = (projectId) => ({
  type: GET_REGISTRY_BOOK_VERSIONS,
  projectId
});
const getRegistryBookVersionsSuccess = (payload) => ({
  type: GET_REGISTRY_BOOK_VERSIONS_SUCCESS,
  payload
});
const getRegistryBookVersionsFailure = (error) => ({
  type: GET_REGISTRY_BOOK_VERSIONS_FAILURE,
  error
});

// Get Material Registry Report Versions Actions (for /material-registry-documents endpoint)
const getMaterialRegistryReportVersions = (projectId) => ({
  type: GET_MATERIAL_REGISTRY_REPORT_VERSIONS,
  projectId
});
const getMaterialRegistryReportVersionsSuccess = (payload) => ({
  type: GET_MATERIAL_REGISTRY_REPORT_VERSIONS_SUCCESS,
  payload
});
const getMaterialRegistryReportVersionsFailure = (error) => ({
  type: GET_MATERIAL_REGISTRY_REPORT_VERSIONS_FAILURE,
  error
});

// Material Traceability All Summary Actions
const getMaterialTraceabilityAllSummary = (payload) => ({
  type: GET_MATERIAL_TRACEABILITY_ALL_SUMMARY,
  payload
});
const getMaterialTraceabilityAllSummarySuccess = (payload) => ({
  type: GET_MATERIAL_TRACEABILITY_ALL_SUMMARY_SUCCESS,
  payload
});
const getMaterialTraceabilityAllSummaryFailure = (error) => ({
  type: GET_MATERIAL_TRACEABILITY_ALL_SUMMARY_FAILURE,
  error
});

// Material Traceability All Data Actions
const getMaterialTraceabilityAllData = (payload) => ({
  type: GET_MATERIAL_TRACEABILITY_ALL_DATA,
  payload
});
const getMaterialTraceabilityAllDataSuccess = (payload) => ({
  type: GET_MATERIAL_TRACEABILITY_ALL_DATA_SUCCESS,
  payload
});
const getMaterialTraceabilityAllDataFailure = (error) => ({
  type: GET_MATERIAL_TRACEABILITY_ALL_DATA_FAILURE,
  error
});

export {
  getListMaterialCategory, 
  getListMaterialCategorySuccess, 
  getListMaterialCategoryFailure,
  getAllMaterials, 
  getAllMaterialsSuccess, 
  getAllMaterialsFailure,
  generateMaterialReport,
  generateMaterialReportSuccess,
  generateMaterialReportFailure,
  clearGenerateMaterialReport,
  getMaterialReportVersions,
  getMaterialReportVersionsSuccess,
  getMaterialReportVersionsFailure,
  generateMaterialRegistryReport,
  generateMaterialRegistryReportSuccess,
  generateMaterialRegistryReportFailure,
  clearMaterialRegistryReport,
  getRegistryReportVersions,
  getRegistryReportVersionsSuccess,
  getRegistryReportVersionsFailure,
  getInspectionPersonnelDocuments,
  getInspectionPersonnelDocumentsSuccess,
  getInspectionPersonnelDocumentsFailure,
  getRegistryBookVersions,
  getRegistryBookVersionsSuccess,
  getRegistryBookVersionsFailure,
  getMaterialRegistryReportVersions,
  getMaterialRegistryReportVersionsSuccess,
  getMaterialRegistryReportVersionsFailure,
  getMaterialTraceabilityAllSummary,
  getMaterialTraceabilityAllSummarySuccess,
  getMaterialTraceabilityAllSummaryFailure,
  getMaterialTraceabilityAllData,
  getMaterialTraceabilityAllDataSuccess,
  getMaterialTraceabilityAllDataFailure,
};

